import { AxiosInstance } from 'axios';
import { BillingApi } from './billing.api';
import { BoardsApi } from './boards.api';
import { BoardTemplatesApi } from './boardTemplates.api';
import { SourceSettingsApiRegistry } from '../sources/SourceSettingsRegistry';
import { SourcesApi } from './sources.api';
import { TasksApi } from './tasks.api';
import { StatusesApi } from './statuses.api';
import { FeaturesApi } from './features.api';
import { ScheduleApi } from './schedule.api';
import { FeedbackApi } from './feedback.api';
import { ProfileApi } from './profile.api';
import { PushDevicesApi } from './pushDevices.api';

/**
 * Main API facade that provides access to all API endpoints
 * Platform-agnostic
 */
export class ApiService {
  public readonly billing: BillingApi;
  public readonly boards: BoardsApi;
  public readonly boardTemplates: BoardTemplatesApi;
  public readonly connectionSourceSettings: SourceSettingsApiRegistry;
  public readonly sources: SourcesApi;
  public readonly tasks: TasksApi;
  public readonly statuses: StatusesApi;
  public readonly feedback: FeedbackApi;
  public readonly features: FeaturesApi;
  public readonly schedule: ScheduleApi;
  public readonly profile: ProfileApi;
  public readonly pushDevices: PushDevicesApi;

  constructor(client: AxiosInstance) {
    this.billing = new BillingApi(client);
    this.boards = new BoardsApi(client);
    this.boardTemplates = new BoardTemplatesApi(client);
    this.connectionSourceSettings = new SourceSettingsApiRegistry(client);
    this.sources = new SourcesApi(client);
    this.tasks = new TasksApi(client);
    this.statuses = new StatusesApi(client);
    this.feedback = new FeedbackApi(client);
    this.features = new FeaturesApi(client);
    this.schedule = new ScheduleApi(client);
    this.profile = new ProfileApi(client);
    this.pushDevices = new PushDevicesApi(client);
  }
}

// Export everything
export * from './client';
export * from './billing.api';
export * from './billingErrors';
export * from './boards.api';
export * from './boardTemplates.api';
export * from './sources.api';
export * from './tasks.api';
export * from './statuses.api';
export * from './feedback.api';
export * from './features.api';
export * from './schedule.api';
export * from './profile.api';
export * from './pushDevices.api';
